import { render, staticRenderFns } from "./houseForm.vue?vue&type=template&id=2389f1f9&scoped=true&"
import script from "./houseForm.vue?vue&type=script&lang=js&"
export * from "./houseForm.vue?vue&type=script&lang=js&"
import style0 from "./houseForm.vue?vue&type=style&index=0&id=2389f1f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2389f1f9",
  null
  
)

export default component.exports